import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {ServicesModelService} from '../../Models/Core/services-model.service';

@Injectable({
  providedIn: 'root'
})
export class ServicesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ServicesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los servicios
   *
   */
  public getServices(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getServiciosRestauracion', {todos: 1}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
